// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var AppConfig$SmartcutsMacros = require("../../../src/common/AppConfig.bs.js");

function hostnameForUser(user) {
  var match = user.role;
  if (match === "REVIEWER") {
    return process.env.HOSTNAME_CHROME_REVIEW;
  } else if (Caml_obj.caml_equal(user.build, "CANARY")) {
    return process.env.NEXT_PUBLIC_CANARY_ORIGIN;
  } else {
    return process.env.HOSTNAME;
  }
}

var domSnapshots = Caml_obj.caml_equal(process.env.DOM_SNAPSHOTS, "true");

var htmlPreprocessing = Caml_obj.caml_equal(process.env.HTML_PREPROCESSING, "true");

var Default = {
  millisecondsBetweenCommands: 300,
  millisecondsBetweenTypingCharacter: 50,
  millisecondsBetweenKeyDownKeyUp: 10,
  millisecondsBetweenTypingCharacterAndNonCharacterKeypress: 400,
  useFastestTypePlayback: true,
  replaceUiCommandsWithApiCommands: true,
  domSnapshots: domSnapshots,
  numConsecutiveFailuresBeforeExit: 5,
  htmlPreprocessing: htmlPreprocessing
};

var OAuth = {
  googleApiKey: "AIzaSyCMyVKWlffaM43SBZMePIzwZyN-8HyTHG8"
};

var Dev = {
  projectDir: "__PROJECT__DIR__"
};

function extensionUrl(user) {
  var match = process.env.HOST_EXTENSION;
  if (match !== undefined) {
    if (match === "1") {
      return hostnameForUser(user) + "/app/download";
    } else {
      return "https://chrome.google.com/webstore/detail/" + AppConfig$SmartcutsMacros.extensionId;
    }
  } else {
    return "https://chrome.google.com/webstore/detail/" + AppConfig$SmartcutsMacros.extensionId;
  }
}

var shouldSaveRecordingCommandLog = false;

exports.hostnameForUser = hostnameForUser;
exports.shouldSaveRecordingCommandLog = shouldSaveRecordingCommandLog;
exports.Default = Default;
exports.OAuth = OAuth;
exports.Dev = Dev;
exports.extensionUrl = extensionUrl;
/* domSnapshots Not a pure module */
